import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    this.dimmer = document.createElement('div')
    this.dimmer.style.position = 'absolute'
    this.dimmer.style.top = 0
    this.dimmer.style.left = 0
    this.dimmer.style.background = '#fff'
    this.dimmer.style.width = this.element.clientWidth + 'px'
    this.dimmer.style.height = this.element.clientHeight + 'px'
    this.dimmer.style.opacity = 0
    this.dimmer.style.pointerEvents = 'none'
    this.element.appendChild(this.dimmer)

    window.addEventListener('scroll', (e) => {
      this.dimmer.style.opacity = window.scrollY / this.dimmer.clientHeight
    })
  }
}